import { Avatar } from '@mui/material';
import { MdInfoOutline } from 'react-icons/md';
import { ICandidate } from 'wisestep-api';
import { WsColors, WsButton } from 'wisestep-base';

import SuccessMessageLayout from '../../../components/SuccessMessageLayout';
import { getDncMessage } from '../../../utils/DncMessage';
interface CustomDNCMessagePros {
  candidate: ICandidate;
  onClick: () => void;
}
const CustomDNCMessage = ({ candidate, onClick }: CustomDNCMessagePros) =>
  candidate.dncDetails && (
    <SuccessMessageLayout
      isHtml={true}
      message={getDncMessage(
        candidate.dncDetails,
        candidate.dncDetails?.isAddedByCandidate
          ? candidate.name
          : candidate.dncDetails?.modifiedBy ?? ''
      )}
      icon={
        <Avatar sx={{ backgroundColor: WsColors.Yellow500, m: 'auto' }}>
          <MdInfoOutline />
        </Avatar>
      }
      button={
        <WsButton onClick={onClick} type="button" variant="text">
          Manage Data Privacy options
        </WsButton>
      }
    />
  );

export default CustomDNCMessage;
